import { ObjectField } from "../models/ObjectField";

export class QueryColumn {
    Id: number | string | null;
    Tenant: number;
    QueryCode: string;
    ObjectFieldCode: string | null;
    ObjectField: ObjectField | null;
    IndexOrder: number;
    IsDefaultSort: boolean;
    IsDeleted: boolean;
    Width: string;
}